import React from "react";

const GoogleAnalytics: React.FC = () => {
  return (
    <React.Fragment>
      {/* Google analytics */}
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-6L5HK6Z3YT"
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-6L5HK6Z3YT');
          `,
        }}
      ></script>
    </React.Fragment>
  );
};

export default GoogleAnalytics;
